// components/Commitment.js (actualizado)
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Commitment = () => {
    const commitments = [
        "Cumplimiento normativo y seguridad de la información",
        "Transparencia y trazabilidad en los procesos",
        "Comunicación constante con los equipos públicos",
        "Soluciones sostenibles y escalables"
    ];

    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-6">
                <ScrollAnimation>
                    <h2 className="text-3xl font-bold font-poppins text-grafito mb-8 text-center">Compromiso</h2>
                </ScrollAnimation>
                <div className="max-w-4xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {commitments.map((commitment, index) => (
                            <ScrollAnimation key={index} delay={0.2 + index * 0.1}>
                                <div className="flex items-center bg-gray-50 p-4 rounded-lg hover:bg-lima hover:bg-opacity-10 transition-colors">
                                    <div className="bg-lima rounded-full p-2 mr-4">
                                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                    </div>
                                    <span className="text-grafito font-lato font-medium">{commitment}</span>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Commitment;
